/*

  ______  _____   ______ _______  ______
 |_____/ |     | |  ____ |______ |_____/
 |    \_ |_____| |_____| |______ |    \_

 vehicle sales system

(c) 2006 - 2019 TCE <TCE-ITDevelopers@toyota-ce.com>

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

(function () {
    "use strict";

    angular
        .module("ROGER")

        //
        .controller("BonusCarsController", [
            "$scope", "$sessionStorage", "$http", "$uibModal", "$location", "$user", "$oidc",
            function ($scope, $sessionStorage, $http, $uibModal, $location, user, oidc) {
                $scope.$storage = $sessionStorage;
                $scope.user = user;

                $scope.modelName = null;
                $scope.modelNames = null;

                $scope.$watch("$storage.retailer", function (newValue, oldValue) {
                    if (newValue.Id !== oldValue.Id && newValue.Id > 0) {
                        $scope.loadModelNames($scope.$storage.bonusCatalog.modelNameId);
                    }
                });

                $scope.list = [];
                $scope.browse = function (modelNameId) {
                    $http.get("/api/bonus-catalog/bonus-cars", {
                        params: {
                            retailerId: $scope.$storage.retailer.Id,
                            modelNameId: modelNameId
                        },
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        }
                    }).then(function (response) {
                        $scope.list = response.data;
                    });
                };

                $scope.isAlreadyInCart = function (unitId) {
                    for (var idx = 0; idx < $scope.$storage.shoppingCart.length; idx++) {
                        if ($scope.$storage.shoppingCart[idx].data.UnitId === unitId)
                            return true;
                    }
                    return false;
                };

                $scope.loadModelNames = function (id) {
                    $http
                        .get("/api/bonus-catalog/model-names", {
                            params: {
                                retailerId: $scope.$storage.retailer.Id
                            },
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            }
                        })
                        .then(function (response) {
                            $scope.modelNames = response.data;
                            $scope.modelName = id !== null ? $scope.modelNames.filter(function (item) { return item.Id === id; })[0] : $scope.modelNames[0];

                            if ($scope.modelName === null) {
                                $scope.modelName = $scope.modelNames[0];
                            }

                            $scope.browse($scope.modelName ? $scope.modelName.Id : null);
                        });
                };

                $scope.onModelNameChanged = function () {
                    $scope.$storage.bonusCatalog.modelNameId = $scope.modelName ? $scope.modelName.Id : null;

                    $scope.browse($scope.modelName ? $scope.modelName.Id : null);
                };

                // Sorting
                $scope.sorting = function (orderName) {
                    if ($scope.$storage.bonusCars.orderName === orderName) {
                        $scope.$storage.bonusCars.orderDesc = !$scope.$storage.bonusCars.orderDesc;
                    } else {
                        $scope.$storage.bonusCars.orderName = orderName;
                        $scope.$storage.bonusCars.orderDesc = false;
                    }
                };

                $scope.sortingClass = function (orderName) {
                    if ($scope.$storage.bonusCars.orderName === orderName) {
                        if ($scope.$storage.bonusCars.orderDesc) {
                            return "fa fa-caret-down";
                        } else {
                            return "fa fa-caret-up";
                        }
                    } else {
                        return "";
                    }
                };

                // Add to order
                $scope.addToOrder = function (item) {
                    $uibModal
                        .open({
                            template: require("./BonusCarsAddToOrder.html"),
                            controller: "BonusCarsAddToOrderController",
                            resolve: {
                                bonusCar: function () {
                                    return item;
                                }
                            }
                        })
                        .result
                        .then(function () {
                        }, function () { });
                };

                if ($scope.$storage.retailer !== null && $scope.$storage.retailer.Id > 0) {
                    $scope.loadModelNames($scope.$storage.bonusCatalog.modelNameId);
                }
            }
        ]);
})();